import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(admin)/layout.tsx")